import {useEffect,useRef,useState} from 'react';
import {explorerApi,type FolderLocation} from './explorerApi';
import {emptySearch,searchFolders,type FileSearch,type SearchProgress} from './explorerSearch';
type Result=SearchProgress&{running:boolean;stopped:boolean;error:string};
export function useExplorerSearch(){
  const [filters,setFilters]=useState<FileSearch>(emptySearch),[result,setResult]=useState<Result|null>(null);
  const active=useRef<AbortController|null>(null);
  useEffect(()=>()=>active.current?.abort(),[]);
  const clear=()=>{active.current?.abort();active.current=null;setResult(null);};
  const run=(at:FolderLocation,criteria:FileSearch)=>{
    active.current?.abort();const controller=new AbortController();active.current=controller;setFilters(criteria);
    setResult({files:[],folders:0,checked:0,skipped:0,limited:false,running:true,stopped:false,error:''});
    void searchFolders(at,criteria,{signal:controller.signal,load:explorerApi.list,onProgress:progress=>{
      if(active.current===controller)setResult({...progress,running:true,stopped:false,error:''});
    }}).then(progress=>{if(active.current===controller)setResult({...progress,running:false,stopped:false,error:''});})
    .catch(error=>{if(active.current===controller&&!controller.signal.aborted)setResult(current=>current&&({...current,running:false,error:error instanceof Error?error.message:'Не удалось выполнить поиск.'}));});
  };
  const stop=()=>{active.current?.abort();active.current=null;setResult(current=>current&&({...current,running:false,stopped:true}));};
  return {filters,result,run,stop,clear};
}
